import axios from 'axios';

const api = axios.create({
  //baseURL: "http://192.168.29.250:7002/api/"
    baseURL: "https://dignosticcenter-service.swasthyakhata.com/"
});

export default api;